import { formatDistanceToNow } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { LeadStage, type Lead } from '@/types/leads'
import { parseDbTimestamp } from '@/utils/datetime'

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

export function formatLeadValue(value: number | null | undefined): string | null {
  return value ? BRL.format(value) : null
}

/** "há 3 dias" a partir do timestamp do banco; '-' se inválido. */
export function leadCreatedAgo(lead: Pick<Lead, 'createdAt'>): string {
  const createdAt = parseDbTimestamp(lead.createdAt)
  return createdAt ? formatDistanceToNow(createdAt, { addSuffix: true, locale: ptBR }) : '-'
}

/** Link do WhatsApp com mensagem inicial; sem código de país, assume +55. */
export function leadWhatsAppUrl(lead: Pick<Lead, 'whatsapp' | 'name' | 'companyName'>): string | null {
  if (!lead.whatsapp) return null
  const raw = lead.whatsapp.trim()
  const phone = raw.startsWith('+') ? raw.replace(/[^\d+]/g, '') : '+55' + raw.replace(/\D/g, '')
  const message = encodeURIComponent(
    `Olá ${lead.name}, tudo bem? Sou da ${lead.companyName || 'empresa'} e gostaria de conversar sobre sua necessidade jurídica.`
  )
  return `https://wa.me/${phone}?text=${message}`
}

/** Estágios ativos (Convertido e Perdido são os arquivados). */
export const ACTIVE_LEAD_STAGES: LeadStage[] = [
  LeadStage.CONTATO_INICIAL,
  LeadStage.QUALIFICACAO,
  LeadStage.DISCUSSAO,
  LeadStage.DECISAO,
]

export const ARCHIVED_LEAD_STAGES: LeadStage[] = [LeadStage.CONVERTIDO, LeadStage.PERDIDO]
